import React from 'react';

import classNames from 'classnames/bind';
import style from './LeftBanner.scss';
const ctx = classNames.bind(style);

import ArticleSpreader from '../ArticleSpreader';

const LeftBanner = props => (
  <div className={ctx('limiter')}>
    <div
      className={ctx('banner')}
      style={{ backgroundImage: `url(${props.image})` }}
    >
      <ArticleSpreader>
        <div className={ctx('text-container')}>
          <div className={ctx('text')}>
            {props.children}
            <div className={ctx('rectangle')} />
          </div>
        </div>
      </ArticleSpreader>
    </div>
  </div>
);

export default LeftBanner;
